<template>
  <div class="tw:flex tw:justify-center tw:gap-2">
    <EdroneButton type="link-text" @click="$emit('click')">
      <slot>
        {{ trans.goToPricing }}
      </slot>
      <template #right-icon>
        <FontAwesomeIcon icon="fa-light fa-arrow-up-right-from-square" />
      </template>
    </EdroneButton>

    <RouterLink v-if="!removeTrackerData?.trackerLeavingId" class="tw:flex" :to="{ name: 'PageCancellation' }">
      <EdroneButton type="danger-outline">
        {{ trans._cancellation.cancelSub }}
        <template #right-icon>
          <FontAwesomeIcon icon="fa-light fa-arrow-up-right-from-square" />
        </template>
      </EdroneButton>
    </RouterLink>
  </div>
</template>

<script setup lang="ts">
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import EdroneButton from "edrone-components/EdroneButton.vue";
import useRestoreTracker from "vue-app/composables/useRestoreTracker";

defineEmits(["click"]);

const { removeTrackerData } = useRestoreTracker();
</script>
